import React from 'react';
import Text from './base';

const SmallAlt = props => (
  <Text defaultTag="small" variant="smallAlt" {...props} />
);

export default SmallAlt;
